import { 
  collection, 
  doc, 
  getDocs, 
  getDoc, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  query, 
  orderBy,
  serverTimestamp
} from 'firebase/firestore';
import { db } from '../firebase/config';

const COLLECTION_NAME = 'games';

export const gamesService = {
  // Получить все игры
  async getAllGames() {
    try {
      const q = query(collection(db, COLLECTION_NAME), orderBy('createdAt', 'desc'));
      const querySnapshot = await getDocs(q);
      return querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
    } catch (error) {
      console.error('Error getting games:', error);
      throw error;
    }
  },

  // Получить игру по ID
  async getGameById(id) {
    try {
      const docRef = doc(db, COLLECTION_NAME, id);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        return { id: docSnap.id, ...docSnap.data() };
      } else {
        throw new Error('Game not found');
      }
    } catch (error) {
      console.error('Error getting game:', error);
      throw error;
    }
  },

  // Создать новую игру
  async createGame(gameData) {
    try {
      const docRef = await addDoc(collection(db, COLLECTION_NAME), {
        ...gameData,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
        players: 0,
        rating: 0
      });
      return docRef.id;
    } catch (error) {
      console.error('Error creating game:', error);
      throw error;
    }
  },

  // Обновить игру
  async updateGame(id, gameData) {
    try {
      const docRef = doc(db, COLLECTION_NAME, id);
      await updateDoc(docRef, {
        ...gameData,
        updatedAt: serverTimestamp()
      });
    } catch (error) {
      console.error('Error updating game:', error);
      throw error;
    }
  },

  // Удалить игру
  async deleteGame(id) {
    try {
      const docRef = doc(db, COLLECTION_NAME, id);
      await deleteDoc(docRef);
    } catch (error) {
      console.error('Error deleting game:', error);
      throw error;
    }
  }
};
